export default {"src":"/_next/static/media/arrow-down.d33b66dd.svg","height":21,"width":41,"blurWidth":0,"blurHeight":0};